import request from '@/utils/common_req'
import gateway_request from '@/utils/gateway_req'

const api = {
    // 留言信息查询
    checkLeaveMessage(params){
        return gateway_request({
            url: '?s=Customer.Messages.Check',
            method: 'GET',
            params:params
        })
    },
    getMessageType(params){
        return request({
            url: '?s=Customer.Messages.Types',
            method: 'GET',
            params:params
        })
    },
    // 提交留言
    sendLeaveMessage(params){
        return gateway_request({
            url: '?s=Customer.Messages.Send',
            method: 'POST',
            data:params
        })
    },
    // 获取电话
    getPhone(params){
        return request({
            url:  process.env.VUE_APP_UPLOAD_API+'index/messages/getPhone',
            method: 'GET',
            params:params
        })
    },
    // 改变客服消息状态
    setMsgRead(params){
        return request({
            url: '?s=Customer.UserSession.setMsgRead',
            method: 'GET',
            params:params
        })
    },
	//提交满意度评价
	saveEvaluateMsg(params){
        return gateway_request({
            url: '?s=Customer.UserSession.saveSatisfaction',
            method: 'POST',
            data:params
        })
    },

}

export default api